import { getRuntimeConfig } from "../config";

// Session lives only in an HttpOnly Secure SameSite cookie set by the API
// (docs/09-frontend-surface.md §3). The browser holds no bearer token and
// reads no tenant scope; this module only decides WHEN to hand off to the
// API-driven OIDC/SAML redirect, never how to mint or refresh credentials.

let redirecting = false;

// Module-level signal flipped by the client when a request comes back
// unauthenticated, so the router guard can short-circuit subsequent
// navigations instead of rendering a protected screen.
let sessionUnauthenticated = false;

export function isSessionUnauthenticated(): boolean {
  return sessionUnauthenticated;
}

// Hand off to the API-driven OIDC/SAML redirect. Idempotent: a burst of 401s
// triggers exactly one navigation.
export function beginOidcRedirect(): void {
  sessionUnauthenticated = true;
  if (redirecting) {
    return;
  }
  redirecting = true;
  const { authLoginPath } = getRuntimeConfig();
  const loginUrl = new URL(authLoginPath, window.location.origin);
  loginUrl.searchParams.set("return_url", window.location.href);
  window.location.assign(loginUrl.toString());
}
